import type {
    DropdownData,
} from '@fitogest/reactive-form-builder/interfaces';
import { list } from 'src/app/common/classes/request-builder';

import { ClienteModel } from 'src/app/models/cliente.model';
import { ProductosModel } from 'src/app/models/productos/productos.model';
import { Uso } from 'src/app/models/productos/uso.model';

export class TratamientosListsDefinition {

    public clientes: DropdownData<ClienteModel> = list<ClienteModel>(['...', null]);

    public productos: DropdownData<ProductosModel> = list<ProductosModel>(['...', null]);

    /**
     * Optional full product catalog.
     * Useful when one environment shows all products and another applies filters.
     */
    public productosAll: DropdownData<ProductosModel> = list<ProductosModel>(['...', null]);

    /**
     * Dynamic row-level dropdown sources.
     * They are kept here for consistency with the rest of reactive forms.
     */
    public usosPlaceholder: DropdownData<Uso> = list<Uso>(['...', null]);

    public agentesPlaceholder: DropdownData<Uso> = list<Uso>(['...', null]);

    public unidadesMedida: DropdownData<string> = list(
        ['...', null],
        'kg/ha',
        'L/ha',
        'kg',
        'L',
        '%',
        'cc/100 L',
        'cc/100L'
    );
}